import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

const CookieAlert = () => {
    const [open, setOpen] = useState(false);
  
    useEffect(() => {
        const cookieConsent = localStorage.getItem("cookieConsent");
        if (!cookieConsent) {
            setOpen(true);
        }
    }, []);

    const handleDismiss = () => {
        localStorage.setItem("cookieConsent", "true");
        setOpen(false);
    };
    

    return (
        <Snackbar open={open} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} onClose={handleDismiss}>
            <Alert onClose={handleDismiss} severity="info" action={<Button color="inherit" size="small" onClick={handleDismiss}>Ok</Button>}>
                Esta aplicação web utiliza cookies para melhorar a experiência do utilizador. Ao utilizar o nosso site, concorda com a nossa política de cookies.
            </Alert>
        </Snackbar>
    );
};

export default CookieAlert;
